module.exports = __webpack_public_path__ + "img/service-sec03-img03.f814f5f1.jpg";